module.exports = __webpack_public_path__ + "static/img/logo.2c676965.png";